export default {
  black: '#000000',
  white: '#FFFFFF',
  current: 'currentColor',
  transparent: 'transparent',
  gray: {
    50: '#F6F7F8',
    100: '#F0F2F3',
    200: '#E3E6E9',
    300: '#C8CED4',
    400: '#A8AFB6',
    500: '#8C929B',
    600: '#757C83',
    700: '#5C6267',
    800: '#383E43',
    900: '#21272A',
    950: '#121619'
  },
  violet: {
    50: '#F3F3FF',
    100: '#F0F0FF',
    200: '#D4CFFF',
    300: '#B4ADFF',
    400: '#978EF8',
    500: '#7B70F9',
    600: '#5E50FA',
    700: '#4939F3',
    800: '#3227A3',
    900: '#1E1678',
    950: '#110B4F'
  },
  pink: {
    50: '#FFF2FC',
    100: '#FFEBF4',
    200: '#FFD8E5',
    300: '#FFB1CB',
    400: '#FF7BA7',
    500: '#F5538A',
    600: '#E22262',
    700: '#C70948',
    800: '#900B38',
    900: '#4E001A',
    950: '#2F0010'
  },
  blue: {
    50: '#F0F7FF',
    100: '#E9F3FF',
    200: '#C7DEFE',
    300: '#A3C9FF',
    400: '#6CA9FF',
    500: '#3A8CFF',
    600: '#0F73FE',
    700: '#0062F5',
    800: '#054AAA',
    900: '#002C68',
    950: '#001F4B'
  },
  red: {
    50: '#FFF3F3',
    100: '#FFEFEF',
    200: '#FFC3C3',
    300: '#FFA3A3',
    400: '#FF7676',
    500: '#FA4C4C',
    600: '#F02828',
    700: '#DF0000',
    800: '#A00A0A',
    900: '#5C0000',
    950: '#3C0000'
  },
  orange: {
    50: '#FFF7EE',
    100: '#FFF2E5',
    200: '#FFD6B2',
    300: '#FFC999',
    400: '#FFB370',
    500: '#FF9233',
    600: '#FF7C0A',
    700: '#F16D09',
    800: '#B25300',
    900: '#763700',
    950: '#411E00'
  },
  yellow: {
    50: '#FEFAE3',
    100: '#FDF8D5',
    200: '#FFF4BF',
    300: '#FEEA87',
    400: '#FFE357',
    500: '#FFD70F',
    600: '#F8C200',
    700: '#D19600',
    800: '#8C6500',
    900: '#533C02',
    950: '#3C2B00'
  },
  green: {
    50: '#EEFDF6',
    100: '#E3FBEF',
    200: '#C9F5DE',
    300: '#A3E9C3',
    400: '#83D6A9',
    500: '#47BC7D',
    600: '#1CA45B',
    700: '#009C4F',
    800: '#076B36',
    900: '#024922',
    950: '#003116'
  },
  olive: {
    50: '#F7FBE3',
    100: '#F5FACB',
    200: '#F1F7AD',
    300: '#E9F37E',
    400: '#D7E449',
    500: '#BCCC12',
    600: '#A8B800',
    700: '#889402',
    800: '#6A7400',
    900: '#4D5500',
    950: '#393E00'
  },
  cyan: {
    50: '#ECFBFB',
    100: '#D9FAFC',
    200: '#B8F6F6',
    300: '#9EF0F0',
    400: '#5AE8E8',
    500: '#26D7D7',
    600: '#00C3C3',
    700: '#00A4A4',
    800: '#008282',
    900: '#005A5A',
    950: '#003939'
  },
  cornflower: {
    50: '#F1F3FF',
    100: '#E9ECFF',
    200: '#D6DDFF',
    300: '#ADBBFF',
    400: '#8A9DFF',
    500: '#5E79FF',
    600: '#3F5FFF',
    700: '#2E4AD6',
    800: '#1C33A8',
    900: '#122376',
    950: '#0B1858'
  },
  magenta: {
    50: '#FAF2FC',
    100: '#FBEAFF',
    200: '#F8D9FF',
    300: '#EFA3FF',
    400: '#E466FF',
    500: '#D50AFF',
    600: '#B100D6',
    700: '#9601B5',
    800: '#75008D',
    900: '#4D005E',
    950: '#2C0035'
  }
};
